<app-header></app-header>
<div class="hero__3">

    <div class="container">

        <div class="row align-items-center mb-50 md:space-y-20">
            <div class="col-lg-2">
                <!-- <p class="hero__text color_black">Create, play and earn rewards. </p> -->
            </div>
            <div class="col-lg-8">
                <h1 class="hero__title">
                    <span class="color_brand">Queezme:</span> Quizzes on blockchain which reward it's users (the
                    queezers) !
                </h1>
            </div>
            <div class="col-lg-2">
                <!-- <p class="hero__text color_black">Create, play and earn rewards. </p> -->
            </div>

            <div class="row align-items-center space-y-50 mb-50 md:space-y-20">
                <div class="col-lg-2">
                    <!-- <p class="hero__text color_black">Create, play and earn rewards. </p> -->
                </div>
                <div class="col-lg-8">
                    <h3>
                        Create, learn and earn.
                    </h3>
                </div>
                <div class="col-lg-2">
                    <!-- <p class="hero__text color_black">Create, play and earn rewards. </p> -->
                </div>
            </div>

        </div>


        <div id="about">
            <div class="container">
                <div class="row justify-content-between align-items-center
         sm:space-y-20">
                    <div class="col-md-6">
                        <div class="space-y-20">
                            <h3>For creators:</h3>
                            <h2>Start creating quizzes on blockchain and earn cryptos.</h2>

                            <nav class="navigation" aria-label="Primary">
                                <ul>
                                    <li class="mainlist">Set up your quiz:</li>
                                    <ul>
                                        <li class="listfeature">Questions/Answers</li>
                                        <li class="listfeature">Free / or Paid (queezers have to pay to a fee to access
                                            the quiz)</li>
                                        <li class="listfeature">Start/End dates</li>
                                        <li class="listfeature">Repeatable / repeat period : daily, weekly, monthly</li>
                                    </ul>
                                    <li class="mainlist">Queezme gives you few amount of Queez token for each quiz
                                        created</li>
                                    <li class="mainlist">Queezers pay your fee to access your quiz (goes to quiz pool
                                        lotery)</li>
                                    <li class="mainlist">At the end of the quiz, earn 30% of the quiz pool</li>
                                    <li class="mainlist">Queezers can vote for your quiz and send you Queez or Matic
                                        token</li>
                                </ul>

                            </nav>

                        </div>

                    </div>
                    <div class="col-md-6">
                        <div class="space-y-20">
                            <img class="img-fluid img__logo" src="assets/img/screenshots/create.png" />

                        </div>
                    </div>
                </div>
                <div class="row justify-content-between align-items-center marketing">
                    <div class="col-md-6">
                        <div class="space-y-20">
                            <img class="img-fluid img__logo" src="assets/img/screenshots/question.png" />

                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="space-y-20">
                            <h3>For players</h3>
                            <h2>Play and learn about various subjects</h2>

                            <nav class="navigation" aria-label="Primary">
                                <ul>
                                    <li class="mainlist">Need to pay fee to access a quiz. (goes to quiz pool lotery).
                                    </li>
                                    <li class="mainlist">Play the quiz and improve your skills about a particular
                                        subject</li>
                                    <li class="mainlist">The winner of the quiz will receive 60% of the quiz lotery
                                        pool. The content creator 30% and Queezme 10% (minus the gas fees). </li>
                                    <li class="mainlist">Each queezers (winner or not) will receive a few amount of
                                        Queez token.</li>

                                </ul>

                            </nav>

                        </div>

                    </div>

                </div>

            </div>

            <div class="container">
                <div class="community">
                    <div class="section__head space-y-20">
                        <h3 class="section__title text-center">To sum up, everyone is earning !</h3>

                    </div>


                </div>
            </div>
        </div>

        <div class="container">
            <div class="community">
                <div class="section__head space-y-20">
                    <h3 class="section__title text-center">The QUEEZ Token</h3>
                    <p class="section__text text-center"> The QUEEZ is a standard ERC20 Token. It will be used to reward our Queezers and in a near future to access/pay the quizzes.</p>
                    <p class="section__text text-center"> A liquidity pool will be added on <a href="https://app.uniswap.org/#/swap" target="_blank"><b>Uniswap</b></a> later in 2022, where you will be able to buy or sell your tokens.</p>
                    <p class="section__text text-center"> In the meantime, you can contribute and buy our Queez token in the next section.</p>
                </div>

                <div class="community__items">
                    <div class="row justify-content-center mb-20_reset">
                        <div class="col-md-3">
                           
                        </div>
                        <div class="col-md-3">
                            <div class="item space-y-10">
                                <div class="logo">
                                    <img class="img-fluid img__logo" src="assets/img/logos/icon.png" alt="logo_community">
                                </div>
                                <h5 class="text-center">1,000,000,000</h5>
                                <p class="text-center">Total supply</p>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <!-- <div class="item space-y-10">
                                <div class="logo is_discord">
                                    <img src="assets/img/icons/discord.svg" alt="logo_community">
                                </div>
                                <h5 class="text-center">Discord</h5>
                                <p class="text-center">Understand the progress of our
                                    code and project</p>
                            </div> -->
                        </div>

                    </div>
                </div>
            </div>
        </div>


        <div class="section mt-100" id="contribute">
            <div class="container">
                <div class="section__head">
                    <div class="d-flex justify-content-between sm-column
                align-items-center mb-20">
                        <h2 class="section__title"> Contribute</h2>
                    </div>
                    <div class="d-flex justify-content-between sm-column
            align-items-center mb-20">
                        <p class="color_text section__text"><br>To buy our <b>Queez</b> token you need to connect your <a href="https://metamask.io/" target="_blank">Metamask wallet</a> 
                             on <a href="https://docs.polygon.technology/docs/develop/metamask/config-polygon-on-metamask" target="_blank">Polygon network</a> and have some <a href="https://www.moonpay.com/"
                                target="_blank">MATIC</a>.
                            <br><br>
                            Why Polygon?
                            Polygon offers lower latency and lower gas fees than the Ethereum mainnet, which means for you saving more money when using our application !
                            </p>
                               
                    </div>

                    <p>
                        
                        </p>
                </div>
                <div class="wrapper">

                    <div class="row">
                        <div class="col-lg-6">
                            <div class="card__item five">
                                <div class="card_body space-y-10 space-x-10 d-flex">
                                    <!-- ???? =============== -->
                                    <div>

                                    </div>
                                    <!-- ???? =============== -->
                                    <div class="d-flex flex-column
                                justify-content-center w-100 space-y-10">
                                        <h6>
                                            Queez Token address:<span class="color_text"></span>
                                        </h6>
                                        <div class="hr"></div>
                                        <div class="card_footer d-block space-y-10">
                                            <a class="creators space-x-10">
                                                <div class="avatars">


                                                </div>
                                                <p class="avatars_name txt_sm">
                                                    <a href="{{queezTokenUrl}}" target="_blank">{{queezTokenAdress}}</a>
                                                </p>
                                            </a>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="col-lg-4">


                        </div>
                    </div>
                </div>
                <div class="wrapper">
                    <div class="row" *ngIf="showConnecteWallet">
                        <div class="col-lg-4">
                            <div class="card__item two">
                                <div class="card_body space-y-10 space-x-10 d-flex">
                                    <!-- ???? =============== -->
                                    <div>
                                    </div>
                                    <!-- ???? =============== -->
                                    <div class="d-flex flex-column
                                justify-content-center w-100 space-y-10">
                                        <h6>
                                            Connect wallet with Metamask
                                        </h6>
                                        <div class="hr"></div>
                                        <div class="card_footer d-block space-y-10">
                                            <a class="creators space-x-10">
                                                <div class="avatars">
                                                </div>
                                               
                                            </a>
                                            <div class="d-flex
                                        align-items-center space-x-10
                                        justify-content-between">
                                                <a class="btn btn-sm btn-grad" (click)="authenticate()"
                                                    data-toggle="modal" data-target="#popup_bid">Connect Metamask
                                                    wallet</a>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">

                            <div class="card__item two">
                                <div class="card_body space-y-10 space-x-10 d-flex">
                                    <!-- ???? =============== -->
                                    <div>


                                    </div>
                                    <!-- ???? =============== -->
                                    <div class="d-flex flex-column
                                justify-content-center w-100 space-y-10">
                                        <h6>

                                            Connect wallet with WalletConnect

                                        </h6>
                                        <div class="hr"></div>
                                        <div class="card_footer d-block space-y-10">
                                            <a class="creators space-x-10">
                                                <div class="avatars">


                                                </div>
                                               
                                            </a>
                                            <div class="d-flex
                                        align-items-center space-x-10
                                        justify-content-between">
                                                <a class="btn btn-sm btn-grad" (click)="walletconnect()"
                                                    data-toggle="modal" data-target="#popup_bid">Connect with
                                                    WalletConnect</a>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-center mb-30">
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="!showConnecteWallet">
                        <div class="col-lg-6">
                            <div class="card__item five">
                                <div class="card_body space-y-10 space-x-10 d-flex">
                                    <!-- ???? =============== -->
                                    <div>

                                    </div>
                                    <!-- ???? =============== -->
                                    <div class="d-flex flex-column
                                justify-content-center w-100 space-y-10">
                                        <h6>
                                            You are connected with your wallet at address :<span class="color_text">
                                                {{userAddress}}</span>
                                        </h6>
                                        <div class="hr"></div>
                                        <div class="card_footer d-block space-y-10">
                                            <a class="creators space-x-10">
                                                <div class="avatars">


                                                </div>
                                                <p class="avatars_name txt_sm">
                                                </p>
                                            </a>
                                            <div class="d-flex
                                        align-items-center space-x-10
                                        justify-content-between">
                                                <a class="btn btn-sm btn-grad" (click)="logout()" data-toggle="modal"
                                                    data-target="#popup_bid">Log out</a>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="col-lg-6">

                            <div class="card__item five">
                                <div class="card_body space-y-10 space-x-10 d-flex">

                                    <div>

                                    </div>

                                    <div class="d-flex flex-column
                                justify-content-center w-100 space-y-10">
                                        <h6>
                                            You have a balance of :<br><span class="color_text"> {{userBalance}}
                                                MATIC</span>
                                        </h6>
                                        <div class="hr"></div>
                                        <div class="card_footer d-block space-y-10">
                                            <a class="creators space-x-10">
                                                <div class="avatars">
                                                </div>
                                                <p class="avatars_name txt_sm">
                                                </p>
                                            </a>
                                            <div class="d-flex
                                        align-items-center space-x-10
                                        justify-content-between">
                                                <a class="btn btn-sm btn-grad" href="{{rampUrl}}" target="_blank">Buy
                                                    more MATIC</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-center mb-30">
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="!showConnecteWallet && canBuy">
                        <div class="col-lg-6">

                            <div class="card__item five">
                                <div class="card_body space-y-10 space-x-10 d-flex">
                                    <!-- ???? =============== -->
                                    <div>

                                    </div>
                                    <!-- ???? =============== -->
                                    <div class="d-flex flex-column
                                justify-content-center w-100 space-y-10">
                                        <h6>
                                            Buy QUEEZ TOKEN:<span class="color_text"> </span>
                                        </h6>
                                        <div class="hr"></div>
                                        <div class="card_footer d-block space-y-10">
                                            <div class="row">
                                                <form [formGroup]="buyForm" (ngSubmit)="onSubmit()">


                                                    <div class="col-lg-6">
                                                        <div class="form-group space-y-10">
                                                            <div class="space-y-20">
                                                                <div class="space-y-10">
                                                                    <input id="amount" formControlName="amount"
                                                                        type="text" class="form-control"
                                                                        placeholder="Number of tokens to buy"
                                                                        (ngModelChange)="calculateAmountToPay()">
                                                                    <div *ngIf="form.amount.touched && form.amount.invalid"
                                                                        class="alert alert-danger">
                                                                        <div *ngIf="form.amount.errors.required">Number
                                                                            is required.</div>
                                                                        <div *ngIf="form.amount.errors.pattern">Enter
                                                                            only number.</div>
                                                                    </div>
                                                                </div>
                                                                <div class="space-y-10">
                                                                    <b>Amount to pay:</b> {{amountToPay}} MATIC
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <button *ngIf="!showSpinner" class="btn btn-sm btn-grad"
                                                        type="submit" [disabled]="form.amount.invalid">BUY</button>
                                                    <div class="lds-default" *ngIf="showSpinner">
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

            </div>
        </div>

        <div class="section mt-100" id="roadmap">
            <div class="container">
                <div class="section__head">
                    <div class="d-flex justify-content-between sm-column
                align-items-center mb-20">
                        <h2 class="section__title"> Roadmap</h2>
                        <!-- <a href="/Collections.html" class="btn btn-dark btn-sm">
                    View
                    All</a> -->
                    </div>
                    <!-- <div class="d-flex space-x-10">
                <span class="color_text txt_sm" style="min-width: max-content;">
                    FILTER BY: </span>
                <ul class="menu_categories space-x-20">
                    <li class="d-flex space-x-10 switch_item">
                        <input type="checkbox" id="switch1" checked=""><label
                            for="switch1">Toggle</label>
                        <span> Has list price </span>
                    </li>
                    <li class="d-flex space-x-10 switch_item">
                        <input type="checkbox" id="switch2"><label
                            for="switch2">Toggle</label>
                        <span> Has open offer </span>
                    </li>
                    <li class="d-flex space-x-10 switch_item">
                        <input type="checkbox" id="switch3"><label
                            for="switch3">Toggle</label>
                        <span> Has sold </span>
                    </li>
                </ul>
            </div> -->
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="timeline">
                            <div class="containertimeline left">
                                <div class="date">11/2021</div>
                                <i class="icon fa fa-home"></i>
                                <div class="content">
                                    <h2>Launch of our Queez token</h2>
                                    <p>
                                        Introducing Queezme concept to the public and launching our Queez token, which
                                        could be used to use the services of our dApp Queezme.
                                    </p>
                                </div>
                            </div>
                            <div class="containertimeline right">
                                <div class="date">Q1 2022</div>
                                <i class="icon fa fa-gift"></i>
                                <div class="content">
                                    <h2>Launch of Queezme v1</h2>
                                    <p>
                                        Queezme dApp <a href="www.queezme.io" style="color:black"
                                            target="_blank">www.queezme.io</a> will be launched.
                                    </p>
                                </div>
                            </div>
                            <div class="containertimeline left">
                                <div class="date">Q2 2022</div>
                                <i class="icon fa fa-user"></i>
                                <div class="content">
                                    <h2>Queezme v2</h2>
                                    <p>
                                        Introducing more functionalities such as NFT's.
                                    </p>
                                </div>
                            </div>
                            <div class="containertimeline right">
                                <div class="date">Q3 2022</div>
                                <i class="icon fa fa-running"></i>
                                <div class="content">
                                    <h2>Adding Queez token to Uniswap</h2>
                                    <p>
                                        Adding a liquidity pool for our Queez token to Uniswap to enable our queezers to
                                        buy or sell Queez tokens.
                                    </p>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>




        <div id="team" class="call2action is__light">
            <div class="container">



                <!-- THE TEAM-->
                <div class="row  justify-content-between align-items-center
        sm:space-y-20">
                    <div class="col-12 col-md-6">
                        <div class="space-y-20">
                            <h2>The Team</h2>
                            <p class="color_text section__text">
                                Founded by two frenchs ?
                            </p>

                        </div>
                    </div>
                    <div class="col-md-auto">
                        <!-- <img class="img-fluid img__logo"  
                    src="assets/img/logos/smalllogodquizApp2.png"
                    alt="..."> -->
                    </div>


                    <div class="row align-items-center space-y-20 mb-50 md:space-y-20">
                        <div class="col-lg-6">
                            <div class="creator_item creator_card space-y-10 is_big">
                                <div class="avatars flex-column space-y-10">
                                    <div class="media has_border">
                                        <a routerLink="/profile/1">
                                            <img src="assets/img/avatars/jkaryo.jpeg" alt="Avatar"
                                                class="avatar avatar-md">
                                        </a>
                                        <!-- <div class="has_number">
                                    1
                                </div> -->
                                    </div>
                                    <div class="text-center">
                                        <a routerLink="/profile/1">
                                            <p class="avatars_name large color_black">@jkaryo</p>
                                        </a>
                                        <span class="team_subtitle color_text">Cofounder - COO</span>
                                        <p>Julien has a huge experience... He is living in Paris</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="creator_item creator_card space-y-10 is_big">
                                <div class="avatars flex-column space-y-10">
                                    <div class="media has_border">
                                        <a routerLink="/profile/2">
                                            <img src="assets/img/avatars/csurbier.jpeg" alt="Avatar"
                                                class="avatar avatar-md">
                                        </a>
                                        <!-- <div class="has_number">
                                    2
                                </div> -->
                                    </div>
                                    <div class="text-center">
                                        <a routerLink="/profile/2">
                                            <p class="avatars_name large color_black">@csurbier</p>
                                        </a>
                                        <span class="team_subtitle color_text">Cofounder - CEO/CTO</span>
                                        <p>Christophe has more than twenty years in new technologies as developer, manager R&D, technical leader in different startups.
                                          In 2010, he cofounded iDevotion an iOS native development company, switched to hybrid development with Ionic in 2017, and lookup to blockchain development in 2020.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>

                <!-- START CREATING-->
                <div class="row justify-content-between align-items-center
         sm:space-y-20">
                    <div class="col-md-6">
                        <div class="space-y-20">
                            <!-- <h1>Start creating quizzes or polls on blockchain and be rewarded with cryptos or NFT's.</h1>
                 <p class="color_text section__text">raroin is a shared
                     liquidity NFT
                     market smart contract
                     which
                     is used by multiple websites to provide the users the
                     best
                     possible experience.</p>
                 <a href="more-info.html" class="btn
                     btn-primary">More info</a>
                     -->
                        </div>
                    </div>
                    <div class="col-md-auto">
                        <img class="img-fluid img__logo" style="max-width: 200px;" src="assets/img/logos/icon.png"
                            alt="...">
                    </div>
                </div>
            </div>
        </div>
        <div id ="techno" class="container">
            <div class="community">
                <div class="section__head space-y-20">
                    <h3 class="section__title text-center">Technologies</h3>
                    <!-- <p class="section__text text-center"> Queezme is build with the following technologies</p> -->
                </div>

                <div class="community__items">
                    <div class="row justify-content-center mb-20_reset">
                        <div class="col-md-3">
                            <div class="item space-y-10">
                                <div class="logo is_discord">
                                    <img class="img-fluid img__logo" src="assets/img/logos/hardhat-logo.svg" alt="logo_community">
                                </div>
                                <h5 class="text-center"><a href="https://hardhat.org/" target="_blank">Hardhat</a></h5>
                                <p class="text-center">Ethereum development environment for professionals.</p>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="item space-y-10">
                                <div class="logo is_discord">
                                    <img class="img-fluid img__logo" src="assets/img/logos/polygon-logo.svg" alt="logo_community">
                                </div>
                                <h5 class="text-center"><a href="https://polygon.technology/" target="_blank">Polygon</a></h5>
                                <p class="text-center">Polygon is a Layer-2 scaling solution for Ethereum blockchain.</p>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="item space-y-10">
                                <div class="logo">
                                    <img class="img-fluid img__logo" src="assets/img/logos/moralis-logo.svg" alt="logo_community">
                                </div>
                                <h5 class="text-center"><a href="https://moralis.io/" target="_blank">Moralis</a></h5>
                              
                                <p class="text-center">Moralis is a web3 platform development to build, host and scale dApps.</p>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
<app-footer></app-footer>